import React from 'react';
import { Col, Spinner } from 'react-bootstrap';
import { colors } from '../util/colors';

interface Props{
    mensagem    ?: string | any;
    lg          ?: any;
}

function Loading({ mensagem, lg } : Props) {
    return (
        <Col lg={lg ?? "1"} className="loader-container">
            <Spinner animation="grow" style={{backgroundColor: colors.green5}} />
            <span>{mensagem ?? 'Carregando...'}</span>
        </Col>
    );
}
interface props { condition: boolean }
export function LoadingIf({condition}: props) {
    if(!condition) { return <></>;}
    return (
        <div className="loading-container">
            <Loading />
        </div>
    )
}
export default Loading;